import './footer.css';
import ageCoLogo from '../../assets/img/age_co_logo.jpg';
import dignityLogo from '../../assets/img/dignity_logo.svg';
import footerBanner from '../../assets/img/footer-ribbon.png';

function Footer(props) {
  return (
    <>
        <footer className="footer">
          <p>{props.copy}</p>
        </footer>
        <div className="footer__divider"></div>
        <div className="footer__images">
          <img src={dignityLogo} alt="Dignity Logo" height="40" width="auto"/>
          <img src={ageCoLogo} alt="Age Co Logo" height="40" width="auto"/>
        </div>
        <div className="footer__divider--grey"></div>
        <div className="footer__banner" style={{backgroundImage: `url('${footerBanner}')`}}></div>
    </>
  );
}

export default Footer;